import { render, staticRenderFns } from "./ClinicianPatientMeasures.vue?vue&type=template&id=5b013665"
import script from "./ClinicianPatientMeasures.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports